import { Alert, Link, Typography } from '@mui/material';
import { Trans, useTranslation } from 'react-i18next';
import env from '../../../../config/env';

function RouteHelpAlert() {
  const { t } = useTranslation(['description']);
  const manualLink = env.CLOUDERS_MANUAL_LINK || '#wrong-link';

  return (
    <Alert
      color="primary"
      variant={'standard'}
      severity="info"
      sx={{
        border: 'none',
        backgroundColor: 'transparent',
        margin: 0,
        padding: 0,
      }}
    >
      <Typography variant="body2" sx={{ color: '#717070' }}>
        <Trans
          t={t}
          ns="description"
          i18nKey="routes.info.help"
          components={[
            <Link
              href={manualLink}
              target="_blank"
              rel="noopener noreferrer"
              sx={{
                color: '#5938BD',
                textDecoration: 'underline',
                '&:hover': {
                  textDecoration: 'underline',
                },
              }}
            />,
          ]}
        />
      </Typography>
    </Alert>
  );
}

export default RouteHelpAlert;
